<template lang="pug">
page(
    main-title="Промокоды",
    :links="[{component: 'Promocodes', title: 'Промокоды'}, mode.text]"
)
    template(slot="description") {{ mode.text }} промокода&nbsp;
        span.text-bold {{ promocode.promocode }}

    .panel
        .panel-body
            p.margin-bottom-20 Введите
                code промокод
                |; если он действует только для способа доставки, укажите его;
                | также при необходимости укажите ID ПВЗ, на которые распространяется промокод.
            form(role="form")
                .form-group(:class="{'has-error': !validation.valid}")
                    .vfl-field.input-group(style='width: 100%;')
                        input(type="text",
                              required="",
                              v-model="promocode.promocode",
                              v-on="{blur: onBlur}")
                        span.field-underline
                        label Промокод
                    span.help-block.error(v-if="!validation.valid") {{ validation.message }}
                .form-group
                    v-select-styled(v-model="promocode.delivery_methods",
                                    multiple='',
                                    :on-search="getDeliveryMethods",
                                    field-label="Способы доставки (не обязательно)",
                                    max-height="220px",
                                    :options="deliveryMethods")
                .form-group
                    v-select-styled(v-model="promocode.pvzs",
                                    multiple='',
                                    :on-search="getPvzs",
                                    field-label="ID ПВЗ (не обязательно)",
                                    max-height="170px",
                                    :options="pvzs")
                span Если нужно при использовании данного <code>промокода</code> показывать только <b>выбранные</b> способы доставки:
                .checkbox.clip-check.check-primary
                    input#block_other_dms_input(
                        type="checkbox",
                        :disabled="!(promocode.delivery_methods && promocode.delivery_methods.length)",
                        v-model="promocode.block_other_dms"
                    )
                    label(for="block_other_dms_input") Блокировать остальные способы доставки
                span.help-block.error(v-if="errorMessage") {{ errorMessage }}
                button.btn.btn-o.btn-primary(@click.prevent="save") Сохранить
                button.btn.btn-o.btn-danger.margin-left-4(
                    v-if="mode.type === 'update'",
                    @click.prevent="remove"
                ) Удалить
                button.btn.btn-o.btn-primary.pull-right(@click.prevent="discard") Отмена

</template>

<script>
import vSelectStyled from '@/components/vSelectStyled';
import ajaxRequest from '@/utils/request';
import { getAjaxSearchMethod } from '@/utils/vSelect';
import { SEARCH_DELIVERY_METHOD } from '@/store/api-points';

import cloneDeep from 'lodash/cloneDeep';

const defaultValidation = {
    complete: false,
    valid: true,
    message: ''
};

export default {
    name: 'EditPromocode',
    components: {
        vSelectStyled
    },
    methods: {
        save() {
            if (!this.validation.complete) {
                this.validatePromocode(() => {
                    this.processSave();
                });
            } else {
                this.processSave();
            }
        },
        processSave() {
            if (!this.validation.valid) return;

            if (!(this.promocode.delivery_methods &&
                      this.promocode.delivery_methods.length) &&
                    this.promocode.block_other_dms) {
                this.errorMessage = 'Блокировать остальные способы доставки можно только при выбранных способах доставки. Нам пришлось снять галочку.';
                this.promocode.block_other_dms = false;
                return;
            } else {
                this.errorMessage = null;
            }

            this.$store.dispatch('savePromocode', this.promocode);
        },
        remove() {
            this.$store.dispatch('deletePromocode', this.promocode);
        },
        discard() {
            this.$router.push({name: 'Promocodes'});
        },
        validatePromocode(resolve) {
            if (!this.promocode.promocode || this.promocode.promocode.length < 2) {
                this.validation = {
                    complete: false,
                    valid: false,
                    message: !this.promocode.promocode ? 'Обязательно для заполнения' : 'Введите побольше символов'
                };
                return;
            }
            ajaxRequest({
                url: '/cost_rules/promocode/validate/',
                params: {
                    id: this.promocode.id,
                    promocode: this.promocode.promocode
                },
                success: response => {
                    this.validation = {
                        complete: true,
                        valid: response.valid,
                        message: response.message
                    };
                    resolve && resolve();
                }
            });
        },
        onBlur() {
            if (!this.validation.complete) {
                this.validatePromocode();
            }
        },
        getDeliveryMethods: getAjaxSearchMethod(
            SEARCH_DELIVERY_METHOD,
            'deliveryMethods'
        ),
        getPvzs: getAjaxSearchMethod(
            '/tariffs/pvz/search/',
            'pvzs',
            ['promocode.delivery_methods']
        )
    },
    computed: {
        mode() {
            return {
                text: this.promocode.id ? 'Редактирование' : 'Создание',
                type: this.promocode.id ? 'update' : 'create'
            };
        }
    },
    watch: {
        'promocode.promocode'(val, old) {
            if (val !== old && this.validation !== defaultValidation) {
                this.validation = defaultValidation;
            }
        }
    },
    data() {
        return {
            promocode: cloneDeep(this.$store.state.localStorage.editedPromocode),
            validation: defaultValidation,
            errorMessage: null,

            deliveryMethods: [],
            pvzs: []
        };
    }
};
</script>



// WEBPACK FOOTER //
// src/components/promocodes/EditPromocode.vue